import ApiClient from './ApiClient';

class ProjectStatusReports extends ApiClient {
  constructor() {
    super('status_reports', { accountScoped: true });
    this.projectId = null;
  }

  get url() {
    return `${this.baseUrl()}/projects/${this.projectId}/status_reports`;
  }

  get(projectId) {
    this.projectId = projectId;
    return super.get();
  }

  create(projectId, data) {
    this.projectId = projectId;
    return super.create({ status_report: data });
  }

  update(projectId, id, data) {
    this.projectId = projectId;
    return super.update(id, { status_report: data });
  }

  delete(projectId, id) {
    this.projectId = projectId;
    return super.delete(id);
  }
}

export default new ProjectStatusReports();
